// Cards already reported in the current activity session, as `kind:id`.
const viewedCardKeys = new Set<string>();
const resetListeners = new Set<() => void>();

export const hasViewedCard = (key: string): boolean => viewedCardKeys.has(key);

export const markCardViewed = (key: string): void => {
  viewedCardKeys.add(key);
};

/** Runs on every reset, so a card still on screen can start watching for its view again. */
export const onViewedCardsReset = (listener: () => void): (() => void) => {
  resetListeners.add(listener);
  return () => resetListeners.delete(listener);
};

/** Forgets which cards were already reported, so the next session counts them again. */
export const resetViewedCards = (): void => {
  viewedCardKeys.clear();
  [...resetListeners].forEach((listener) => listener());
};
